import type {UserContentMigrationState} from 'src/openapi/admin/models/UserContentMigrationState';

export enum MIGRATION_STEPS {
    CONFIGURE = 0,
    CONFIRM = 1,
    MIGRATE = 2,
}

export const MIGRATION_STEP_CAPTIONS: Record<MIGRATION_STEPS, string> = {
    [MIGRATION_STEPS.CONFIGURE]: 'Configure',
    [MIGRATION_STEPS.CONFIRM]: 'Confirm',
    [MIGRATION_STEPS.MIGRATE]: 'Migration Result',
};

export const STEPS = [
    {step: MIGRATION_STEPS.CONFIGURE, caption: MIGRATION_STEP_CAPTIONS[MIGRATION_STEPS.CONFIGURE]},
    {step: MIGRATION_STEPS.CONFIRM, caption: MIGRATION_STEP_CAPTIONS[MIGRATION_STEPS.CONFIRM]},
    {step: MIGRATION_STEPS.MIGRATE, caption: MIGRATION_STEP_CAPTIONS[MIGRATION_STEPS.MIGRATE]},
];

export const TYPE_LABELS: Record<string, string> = {
    SAVED_SEARCH: 'Saved Search',
    ALERT: 'Alert',
    LAYOUT: 'Layout',
    SAVED_LIST: 'Saved List',
};

export type Section = {
    key: keyof UserContentMigrationState,
    title: string,
};

export const SECTIONS: Section[] = [
    {key: 'savedSearches', title: 'Saved Searches'},
    {key: 'lists', title: 'Saved Lists'},
    {key: 'emailAlerts', title: 'Alerts'},
    {key: 'layouts', title: 'Layouts'},
];

export const SECTION_ORDER: string[] = [
    'SAVED_SEARCH',
    'SAVED_LIST',
    'ALERT',
    'LAYOUT',
];

export const SECTION_TITLES: Record<string, string> = {
    SAVED_SEARCH: 'Saved Searches',
    SAVED_LIST: 'Lists',
    ALERT: 'Alerts',
    LAYOUT: 'Layouts',
};

export const DEFAULT_PAGE_SIZE = 10;
